import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";

import { MobileEditVisitContainer } from "./MobileEditVisitContainer";

export function MobileEditVisitPage() {
  return (
    <BerlinThemeProvider fullHeight>
      <MobileEditVisitContainer />
    </BerlinThemeProvider>
  );
}
